module.exports = __webpack_public_path__ + "img/noticePoster.d6f4f17e.jpg";